export default {"src":"/_next/static/media/competitive_analysis.28df2d2d.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};